import { defineComponent as _defineComponent } from 'vue';
import { openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createElementVNode as _createElementVNode, withCtx as _withCtx } from "vue";
var _hoisted_1 = { class: "w-full pt-2" };
import { AuthModalStore } from '@student/modules/store';
import { computed, onMounted } from 'vue';
import EDialog from '@common/ui/EDialog.vue';
import AuthModalLogin from '@student/components/Modals/AuthModal/AuthModalLogin.vue';
import AuthModalPasswordRecovery from '@student/components/Modals/AuthModal/AuthModalPasswordRecovery.vue';
import AuthModalRegister from '@student/components/Modals/AuthModal/AuthModalRegister.vue';
export default /*#__PURE__*/ _defineComponent({
    __name: 'AuthModal',
    setup: function (__props) {
        var visible = computed(function () { return AuthModalStore.visible; });
        var action = computed(function () { return AuthModalStore.action; });
        onMounted(function () {
            var hashtag = document.location.hash.slice(1);
            if (hashtag === 'login') {
                AuthModalStore.showLogin();
            }
            else if (hashtag === 'register') {
                AuthModalStore.showRegister();
            }
        });
        var hide = function () {
            AuthModalStore.hide();
        };
        return function (_ctx, _cache) {
            return (_openBlock(), _createBlock(EDialog, {
                visible: visible.value,
                class: "modal",
                name: "auth-login[student]",
                "forcibly-hide-body": "",
                onClose: hide
            }, {
                default: _withCtx(function () { return [
                    _createElementVNode("div", _hoisted_1, [
                        (action.value === 'login')
                            ? (_openBlock(), _createBlock(AuthModalLogin, { key: 0 }))
                            : (action.value === 'password-recovery')
                                ? (_openBlock(), _createBlock(AuthModalPasswordRecovery, { key: 1 }))
                                : (action.value === 'register')
                                    ? (_openBlock(), _createBlock(AuthModalRegister, { key: 2 }))
                                    : _createCommentVNode("", true)
                    ])
                ]; }),
                _: 1
            }, 8, ["visible"]));
        };
    }
});
